export default {
    isLogin: state => {
        console.log('isLogin');
        console.log(state.isLogin);
        return state.isLogin;
    },
};
